$(function() {
  "use strict";
  var contentSectionSelector = ".page-template-page-single-page";
  var $contentSections = $(contentSectionSelector);
  // var $loader = $('#loader');
  // var $countup = $('span.counter');
  var $current_section;
  var active_class = 'active-section';

/* IF DIABLING SCROLIFY ON MOBILE or DISABLE ALTOGETHER, COMMENT OUT THE LINE BELOW */
  // _90dl_scrollify();



/******DISABLE SCROLIFY ON MOBILE *********/

  if($contentSections.length && Foundation.MediaQuery.atLeast('medium')) {
    _90dl_scrollify()
  } else {
      // _90dl_loader($loader, 600);
  }

  $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
  // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
  if(oldSize == 'small' && $.scrollify.isDisabled()) {
    //we are not small anymore
    $.scrollify.enable();
  } else if(oldSize == 'small') {
    _90dl_scrollify();
  }
  if(newSize == 'small') {
    //we are small
    $.scrollify.disable();
    // _90dl_countup($countup);
  }

  });



$(".next-scroll-icon img").click(function() {
  var next = $(this).closest(".page-section").next().offset().top;
  $("html, body").animate({scrollTop: next},800);
});


function _90dl_loader(loader, delay) {
  loader.addClass('loaded');
    setTimeout(function(){
      loader.remove();
    }, parseInt(delay));
  }



  function _90dl_scrollify() {
      $.scrollify({
          section : ".page-section",
          sectionName : "section-name",
          interstitialSection : ".page-section.type-google_connectivity_map",
          easing: "easeOutQuart",
          scrollSpeed: 1400,
          // offset : 140,
          scrollbars: true,
          standardScrollElements: ".site-footer",
          setHeights: false,
          overflowScroll: true,
          updateHash: false,
          touchScroll:true,
          before:function(index, sections) {
            // _90dl_countup($countup);
            $current_section = $.scrollify.current();
            var $next_section = $(sections[index]);
            $('.page-section').removeClass(active_class);
            $next_section.addClass(active_class);

          },
          after:function() {
          },
          afterResize:function() {},
          afterRender:function() {
            $('.page-section').removeClass(active_class);
            $current_section = $.scrollify.current();
            $current_section.addClass(active_class);
            // $('.slick-container').slick();
            // _90dl_loader($loader, 700);
            // _90dl_countup($countup);
          }
      });
  }

  function _90dl_countup($element){
    $element.each(function() {
      if($(this).html != '0') {
        $(this).html('0');
      }
      var $this = $(this),
          countTo = $this.attr('data-count');
      $({ countNum: $this.text()}).animate({
        countNum: countTo
      }, { duration: 1300,
          easing:'linear',
          step: function() {
          $this.text(Math.floor(this.countNum));
        },
          complete: function() {
          $this.text(this.countNum);
        }
      });  
    });
  }

});